enum AnimalsAndEventsTabsKeys {
  events = 'events',
  productivity = 'productivity',
  veterinary = 'veterinary ',
  information = 'information',
  notes = 'notes',
}
export default AnimalsAndEventsTabsKeys;
